import React, { useContext, useEffect } from 'react';

import { safeLocalStorage } from 'Utilities/storages';

import {
  DOCUMENT_CAPTURE_REVIEW_KEY,
} from '../DocumentCapture.helpers';
import { DocumentCaptureOfferContext } from '../DocumentCaptureContexts';
import { DocumentCaptureViewContainer } from '../shared/DocumentCaptureViewContainer/DocumentCaptureViewContainer';

import { ReviewStatusSubview } from './ReviewStatusSubview';

export const ReviewStatusView = () => {
  const { enquiryId } = useContext(DocumentCaptureOfferContext) || {};

  useEffect(() => {
    const reviewVehicles = safeLocalStorage.getItem(DOCUMENT_CAPTURE_REVIEW_KEY) || [];
    const currentEnquiryId = String(enquiryId);

    if (reviewVehicles.includes(currentEnquiryId) || !enquiryId) {
      return;
    }

    reviewVehicles.push(currentEnquiryId);
    safeLocalStorage.setItem(DOCUMENT_CAPTURE_REVIEW_KEY, reviewVehicles);
  }, [enquiryId]);

  return (
    <DocumentCaptureViewContainer>
      <ReviewStatusSubview />
    </DocumentCaptureViewContainer>
  );
};
